export default __webpack_public_path__ + "static/media/catalogiconactive.787e36b1.svg";